import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Instancia sin autenticación — para endpoints públicos
const publicInstance = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Instancia con autenticación — solo para endpoints de admin
export const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Interceptor de auth solo aplicado a la instancia de admin
api.interceptors.request.use((config) => {
  const adminStorage = localStorage.getItem('admin-storage');
  if (adminStorage) {
    try {
      const { state } = JSON.parse(adminStorage);
      if (state?.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
    } catch (e) {
      console.error('Error parsing admin storage:', e);
    }
  }
  return config;
});

// Public endpoints — usan publicInstance (sin token de admin)
export const publicApi = {
  getRoutes: () => publicInstance.get('/routes'),
  createQuote: (data) => publicInstance.post('/quote', data),
  createReservation: (data) => publicInstance.post('/reservations', data),
  getReservation: (id) => publicInstance.get(`/reservations/${id}`),
  updateReservationAddons: (id, addons) => publicInstance.patch(`/reservations/${id}/addons`, { addons }),
  getAddons: () => publicInstance.get('/addons'),
  getPayPalConfig: () => publicInstance.get('/payments/paypal/config'),
  createPayPalOrder: (reservationId) => publicInstance.post('/payments/paypal/create-order', { reservation_id: reservationId }),
  capturePayPalOrder: (reservationId, paypalOrderId) =>
    publicInstance.post('/payments/paypal/capture-order', null, { params: { reservation_id: reservationId, paypal_order_id: paypalOrderId } }),
};

// Admin endpoints
export const adminApi = {
  login: (credentials) => api.post('/admin/login', credentials),
  changePassword: (data) => api.put('/admin/change-password', data),
  
  // Vehicles
  getVehicles: (page = 1, pageSize = 20, search = '') => api.get('/admin/vehicle-types', { params: { page, page_size: pageSize, ...(search && { search }) } }),
  createVehicle: (data) => api.post('/admin/vehicle-types', data),
  updateVehicle: (id, data) => api.put(`/admin/vehicle-types/${id}`, data),
  deleteVehicle: (id) => api.delete(`/admin/vehicle-types/${id}`),
  
  // Routes
  getRoutes: (page = 1, pageSize = 20, search = '') => api.get('/admin/routes', { params: { page, page_size: pageSize, ...(search && { search }) } }),
  createRoute: (data) => api.post('/admin/routes', data),
  updateRoute: (id, data) => api.put(`/admin/routes/${id}`, data),
  deleteRoute: (id) => api.delete(`/admin/routes/${id}`),
  
  // Rates
  getRates: (page = 1, pageSize = 20, search = '') => api.get('/admin/route-vehicle-rates', { params: { page, page_size: pageSize, ...(search && { search }) } }),
  createRate: (data) => api.post('/admin/route-vehicle-rates', data),
  updateRate: (id, data) => api.put(`/admin/route-vehicle-rates/${id}`, data),
  deleteRate: (id) => api.delete(`/admin/route-vehicle-rates/${id}`),
  
  // Addons
  getAddons: (page = 1, pageSize = 20, search = '') => api.get('/admin/addons', { params: { page, page_size: pageSize, ...(search && { search }) } }),
  createAddon: (data) => api.post('/admin/addons', data),
  updateAddon: (id, data) => api.put(`/admin/addons/${id}`, data),
  deleteAddon: (id) => api.delete(`/admin/addons/${id}`),
  
  // Reservations
  getReservations: (page = 1, pageSize = 20, status = '', search = '') => api.get('/admin/reservations', { params: { page, page_size: pageSize, ...(status && { status }), ...(search && { search }) } }),
  createReservation: (data) => api.post('/admin/reservations', data),
  updateReservationStatus: (id, status, reason = '') => api.put(`/admin/reservations/${id}/status`, { status, reason })
};
